import { gql } from "@apollo/client";
import { fetchQuery } from ".";
import { store } from "../redux/store";
import * as actions from "../redux/actions/profile.action";
import { errorToDisplay } from "../helper/CommonFuncs";
import { ShowAlert } from "../common/alert";

export const GET_USER_DATA_WITH_APPOINTMENT = gql`
   query getProfile($options: GetUserProfileOptions) {
      getProfile(options: $options) {
         id
         isFollow
         hasCreatedContent
         colorCode
         dob
         dateOfBirth
         helmetCompletionTime
         preferredLanguage
         hospitals {
            name
            id
         }
         departments {
            name
            id
         }
         enterpriseInfo {
            id
            name
            domain
            loginSystem
            showReferral
            appIntegration
            isTeamsEnabled
         }
         location {
            assignedBed
            assignedRoom
            assignedWard
         }
         name {
            firstName
            lastName
            fullName
            middleName
            initials
         }
         providerInfo {
            degree
            department
            title
            settings
         }
         settings {
            cellToPatient
            cellToProvider
            emailToPatient
            emailToProvider
         }
         contactInformation {
            email
            mobileNumber
            officeNumber
            isCallEnable
         }
         activityNotViewed
         createdAt
         role
         status
      }
   }
`;

export const GET_USER_DATA = gql`
   query getProfile($options: GetUserProfileOptions) {
      getProfile(options: $options) {
         id
         isFollow
         hasCreatedContent
         colorCode
         dob
         dateOfBirth
         playbackAIOnly
         HomeScreen
         isFreemiumVerified
         isFreemiumProvider
         isSSOLogin
         hl7Enable
         extendTrial
         isSubscribed
         isTrialUser
         trialRemaining
         subscription_interval
         referralCode
         referralLink
         nextgenEnable
         isSkipTemplateSelected
         autoSendNotesEHR
         showEhrNoteAutoSendSelection
         noteRecordingTimeLimit
         hospitals {
            name
            id
         }
         departments {
            name
            id
         }
         enterpriseInfo {
            id
            name
            domain
            loginSystem
            showReferral
            appIntegration
            isTeamsEnabled
            noteExpiredPolicyDay
            enableTemplateLibrary
            disableBillingCodes
            enableNoteRulesAndFindings
            disableSharing
            areaCode
            enableHelmetSelect
            showLanguageSelector
         }
         name {
            firstName
            lastName
            fullName
            middleName
            initials
         }
         providerInfo {
            degree
            department
            title
            settings
         }
         settings {
            cellToPatient
            cellToProvider
            emailToPatient
            emailToProvider
            isTemplateAlertShown
         }
         contactInformation {
            email
            mobileNumber
            officeNumber
            isCallEnable
            countryCode
         }
         activityNotViewed
         createdAt
         role
         status
         media {
            mediaId
         }
         isProfileCompleted
         epicEnabled
      }
   }
`;

export const getSelectedPatientProfile = (patientId, initialLoad = false) => {
   const payload = {
      options: {
         id: patientId,
      },
   };
   let selectedPatient = {};
   if (initialLoad) {
      selectedPatient = {
         list: null,
         loading: true,
      };
      store.dispatch(actions.setSelectedPatient(selectedPatient));
   }
   fetchQuery(
      GET_USER_DATA_WITH_APPOINTMENT,
      payload,
      (data) => {
         let patientProfile = data?.data?.getProfile;
         selectedPatient = {
            list: patientProfile,
            loading: false,
         };
         store.dispatch(actions.setSelectedPatient(selectedPatient));
      },
      (error) => {
         let errMsg = errorToDisplay(error);
         ShowAlert(errMsg, "error");
         if (errMsg === "User not found.") {
            store.dispatch(actions.setNoUserFound(true));
         }
      }
   );
};
